export default "__VITE_ASSET__DAOjEZuv__"